import { Box, BoxProps, Flex, Heading, Menu, MenuItemProps, Text } from '@televet/kibble-ui';
import React from 'react';

export interface ParticipantSectionProps<T> {
  title: string;
  participants: T[];
  renderParticipant: (participant: T) => JSX.Element;
  addButtonText: string;
  menuItems: MenuItemProps[];
  onSelect: (selectedItem: MenuItemProps) => void;
  onOpen?: () => void;
  emptyMessage?: string;
  pb?: BoxProps['pb'];
}

const ParticipantSection = <T,>({
  title,
  participants,
  renderParticipant,
  addButtonText,
  menuItems,
  onSelect,
  onOpen,
  emptyMessage,
  pb,
}: ParticipantSectionProps<T>): JSX.Element => {
  return (
    <Box overflow="auto" pb={pb}>
      <Heading size="sm" mb={1} mx={1}>
        {title}
      </Heading>
      <Flex direction="column" mx={1} p={2} gap={4}>
        {participants.length === 0 && emptyMessage && (
          <Text as="p" color="text.danger">
            {emptyMessage}
          </Text>
        )}
        {participants.map(renderParticipant)}
      </Flex>
      <Menu
        buttonProps={{
          variant: 'ghost',
          size: 'sm',
          leftIconName: 'plus',
          showRightIcon: false,
          text: addButtonText,
        }}
        closeOnSelect={false}
        onOpen={onOpen}
        strategy="fixed"
        listProps={{
          maxH: '250px',
          menuItems,
          isMultiSelect: true,
          isGrouped: true,
          isSearchable: true,
          onSelect,
        }}
      />
    </Box>
  );
};

export default ParticipantSection;
